import { RouterTransition } from '@/components/transition'
import { PermissionEnum, RoleEnum } from '@/enums'

export const disciplinaryServiceRouters:any = [
  {
    path: '/DisciplinaryService',
    name: 'DisciplinaryService',
    component: RouterTransition,
    meta: {
      title: '惩戒维权服务',
      icon: 'chengjie',
    },
    redirect: {
      name: 'NoIndustryPenaltyCertificate',
    },
    children: [
      {
        path: '/DisciplinaryService/NoIndustryPenaltyCertificate',
        name: 'NoIndustryPenaltyCertificate',
        component: () => import('@/views/DisciplinaryService/NoIndustryPenaltyCertificate.vue'),
        meta: {
          title: '无行业处分证明开具申请',
          auth: {
            permissions: [PermissionEnum.无行业处分证明开具申请],
            roles: [RoleEnum.member],
            options: {
              priority: 'all',
            }
          },
        },
      },
      {
        path: '/DisciplinaryService/NonIndustryIssue',
        name: 'NonIndustryIssue',
        component: () => import('@/views/DisciplinaryService/NonIndustryIssue.vue'),
        meta: {
          title: '申诉开具证明',
          hideInMenu: true,
          hideBreadcrumb: true,
        },
      },
      {
        path: '/DisciplinaryService/NonIndustryIssueView/:id',
        name: 'NonIndustryIssueView',
        component: () => import('@/views/DisciplinaryService/NonIndustryIssueView.vue'),
        meta: {
          title: '申诉开具证明查看',
          hideInMenu: true,
          hideBreadcrumb: true,
        },
      },
      {
        path: '/DisciplinaryService/SafeguardRightsPage',
        name: 'SafeguardRightsPage',
        component: () => import('@/views/DisciplinaryService/SafeguardRightsPage.vue'),
        meta: {
          title: '我要维权',
          auth: {
            permissions: [PermissionEnum.我要维权],
            roles: [RoleEnum.member],
            options: {
              priority: 'all',
            }
          },
        },
      },
      {
        path: '/DisciplinaryService/SafeguardRightsForm',
        name: 'SafeguardRightsForm',
        component: () => import('@/views/DisciplinaryService/SafeguardRightsForm.vue'),
        meta: {
          title: '维权申请',
          hideInMenu: true,
          hideBreadcrumb: true,
        },
      },
      {
        path: '/DisciplinaryService/SafeguardRightsView/:id',
        name: 'SafeguardRightsView',
        component: () => import('@/views/DisciplinaryService/SafeguardRightsView.vue'),
        meta: {
          title: '律师维权查看',
          hideInMenu: true,
          hideBreadcrumb: true,
        },
      },
      {
        path: '/DisciplinaryService/DocumentSubmissionPage',
        name: 'DocumentSubmissionPage',
        component: () => import('@/views/DisciplinaryService/DocumentSubmissionPage.vue'),
        meta: {
          title: '被调查会员情况说明',
          auth: {
            permissions: [PermissionEnum.被调查会员情况说明],
            roles: [RoleEnum.member],
            options: {
              priority: 'all',
            }
          },
        },
      },
      {
        path: '/DisciplinaryService/DocumentSubmissionForm',
        name: 'DocumentSubmissionForm',
        component: () => import('@/views/DisciplinaryService/DocumentSubmissionForm.vue'),
        meta: {
          title: '被调查会员情况说明',
          hideInMenu: true,
          hideBreadcrumb: true,
        },
      },
      {
        path: '/DisciplinaryService/DocumentSubmissionView/:id',
        name: 'DocumentSubmissionView',
        component: () => import('@/views/DisciplinaryService/DocumentSubmissionView.vue'),
        meta: {
          title: '惩戒人员检查信息',
          hideInMenu: true,
          hideBreadcrumb: true,
        },
      },
    ],
  },
]
